import React, { useMemo } from "react";
import { useMetadata } from "hooks/query";
import { useSection } from "hooks/section";

const UseStartBanner = () => {
    const metadataQuery = useMetadata();
    let { sectionUrl } = useSection();

    return useMemo(() => {
        let matches =
            metadataQuery.isSuccess &&
            metadataQuery.data.banners.$values.filter(
                (value) =>
                    value.position === "Sectionwide" && value.identifier === sectionUrl && value.size === "PanoramaStart"
            );
            
            return matches;
    }, [metadataQuery, sectionUrl]);
};

export default UseStartBanner
